import React, { useEffect, useState } from "react";
import { Box, Button, TextField, MenuItem } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import Header from "../../../components/Header";
import { generateAndExecuteMutation, graphqlQuery } from "../../../data/Axios/DynamicService";
import { salesManagement, setupManagementUrl } from "../../../config";
import { DiscountTypesQuery } from "../../../data/Axios/queries";

const base_url = salesManagement.uri;

const DiscountRuleForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [discounttypesData, setDiscountTypesData] = useState([]);
  const [selectedDiscountType, setSelectedDiscountType] = useState("");

  const userId = parseInt(decodedToken.Id);
  const CompanyId = parseInt(decodedToken.CompanyId);
  const RegionId = parseInt(decodedToken.RegionId);
  const BranchId = parseInt(decodedToken.BranchId);

  const initialValues = {
    discountFlatAmount: props.data ? props.data.discountFlatAmount : "",
    discountTypeId: props.data ? props.data.discountTypeId : "",
    minPurchaseAmount: props.data ? props.data.minPurchaseAmount : "",
    discountPercentage: props.data ? props.data.discountPercentage : "",
  };

  const validationSchema = yup.object().shape({
    // discountFlatAmount: yup.string().required("Discount Flat Amount is required"),
    minPurchaseAmount: yup.string().required("Minimum Purchase Amount is required"),
    // discountPercentage: yup.string().required("Discount Percentage is required"),
  });

  useEffect(() => {
    async function fetchAllData() {
      try {
        const discountTypesResponse = await graphqlQuery(DiscountTypesQuery, setupManagementUrl.uri);
        if (discountTypesResponse) {
          setDiscountTypesData(discountTypesResponse);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllData();
  }, []);

  const discounttypesOptions = discounttypesData.map((type) => ({
    value: type.id,
    label: type.name,
  }));

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { discountPercentage, minPurchaseAmount, discountFlatAmount, discountTypeId } = values;

      const mutationData = {
        discountPercentage,
        minPurchaseAmount,
        discountFlatAmount,
        discountTypeId,
        companyId: CompanyId,
        regionId: RegionId,
        branchId: BranchId,
        isActive: true,
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateDiscountRule" : "createDiscountRule",
        mutationData,
        "newDiscountRule",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Discount ${props.isEditing ? "updated" : "created"} successfully.`,
        }).then(() => {
          props.refetchData();
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px" bgcolor="background.paper" p={3}>
      <Header
        title={props.isEditing ? "Edit Discount Rule" : "Create Discount Rule"}
        subtitle={props.isEditing ? "Edit an existing Discount Rule" : "Create a new Discount Rule"}
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
          <TextField
                fullWidth
                variant="filled"
                select
                label="Discount Type *"
                onBlur={handleBlur}
                onChange={(e) => {
                  const value = e.target.value;
                  setFieldValue("discountTypeId", value);

                  // Find the selected discount type name
                  const selectedType = discounttypesData.find((type) => type.id === value);
                  setSelectedDiscountType(selectedType ? selectedType.name : "");
                }}
                value={values.discountTypeId}
                name="discountTypeId"
                error={touched.discountTypeId && !!errors.discountTypeId}
                helperText={touched.discountTypeId && errors.discountTypeId}
              >
                {discounttypesOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Minimum Purchase Amount *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.minPurchaseAmount}
                name="minPurchaseAmount"
                error={touched.minPurchaseAmount && !!errors.minPurchaseAmount}
                helperText={touched.minPurchaseAmount && errors.minPurchaseAmount}
              />

              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Discount Flat Amount *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.discountFlatAmount || 0}
                name="discountFlatAmount"
                disabled={selectedDiscountType === "Flat Rate"} // Disable based on type name
                error={touched.discountFlatAmount && !!errors.discountFlatAmount}
                helperText={touched.discountFlatAmount && errors.discountFlatAmount}
              />

              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Discount Percentage (%)"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.discountPercentage || 0}
                name="discountPercentage"
                disabled={selectedDiscountType === "Flat mount"} // Disable based on type name
                error={touched.discountPercentage && !!errors.discountPercentage}
                helperText={touched.discountPercentage && errors.discountPercentage}
              />

              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default DiscountRuleForm;
